import * as React from 'react'

import { UseFormGetValues, UseFormSetValue } from '~shared/segments/Form'

import { useFormOrderCtx } from '../contexts/FormOrderProvider'
import { TOrderForm } from '../contexts/FormProvider'

type TOptions = {
  setValue: UseFormSetValue<TOrderForm>
  getValues: UseFormGetValues<TOrderForm>
}

/**
 * Pre-fills phone prefix input of the order form
 * based on the country that the branch (the order is assigned to) is in.
 */
export const useCountryPhonePrefix = ({ setValue, getValues }: TOptions) => {
  const order = useFormOrderCtx()
  const refAlreadyRun = React.useRef(false)

  const orderLoaded = order !== null
  const countryPhonePrefix = order?.branch.address.country?.phonePrefix

  React.useEffect(() => {
    if (!orderLoaded || refAlreadyRun.current) {
      return
    }

    refAlreadyRun.current = true

    if (!countryPhonePrefix) {
      return
    }

    const phonePrefixValue = getValues().phonePrefix

    // user has entered some value already (or something was retrieved from the persistence)
    if (phonePrefixValue) {
      return
    }

    setValue(`phonePrefix`, countryPhonePrefix)
  }, [countryPhonePrefix, getValues, orderLoaded, setValue])

  return null
}
